// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"220":"corporate","594":"about"}[chunkId] + "." + {"220":"1bfe6502","594":"77654b98"}[chunkId] + ".js";
};